globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.MulticastNotice = (function(superClass) {

    utils.extend(MulticastNotice, superClass);

    function MulticastNotice() {
        return MulticastNotice.__super__.constructor.apply(this, arguments);
    }

    $.extend(MulticastNotice.prototype, {
        init: function() {
            var modal = this;

            appCustomerSpace.LimitlessPlugins.Tooltip.init(this.$html);
            SearchFilter.initFilters(this.$html.find('.input-filter'));

            return MulticastNotice.__super__.init.apply(this, arguments);
        }
    });

    return MulticastNotice;

})(appCustomerSpace.Modal);
